var _title, _desc, _defs, _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgXlsx = function SvgXlsx(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72px",
    height: "90px",
    viewBox: "0 0 72 90",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "xlsx-ico")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.0909091,-6.80022355e-15 L52.411377,-3.71749449e-15 L66.375,14.668216 L66.375,75.9090909 C66.375,78.1684376 64.5434376,80 62.2840909,80 L11.0909091,80 C8.83156239,80 7,78.1684376 7,75.9090909 L7,4.09090909 C7,1.83156239 8.83156239,-4.02585684e-15 11.0909091,-4.4408921e-15 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-14.3%",
    y: "-8.1%",
    width: "128.6%",
    height: "121.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.16 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "52.625 0 66.588623 14.4848633 52.625 14.4848633"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-46.5%",
    y: "-38.0%",
    width: "193.1%",
    height: "189.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.12 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UIDE-Kit-Copy-2",
    transform: "translate(-5144.000000, -1180.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "xlsx-ico",
    transform: "translate(5144.000000, 1183.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-21",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#D6D6D6",
    strokeWidth: 1,
    d: "M65.875,14.8681527 L52.1970266,0.5 L11.0909091,0.5 C9.10770476,0.5 7.5,2.10770476 7.5,4.09090909 L7.5,75.9090909 C7.5,77.8922952 9.10770476,79.5 11.0909091,79.5 L62.2840909,79.5 C64.2672952,79.5 65.875,77.8922952 65.875,75.9090909 L65.875,14.8681527 Z",
    strokeLinejoin: "square",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-21-Copy",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DFDFDF",
    strokeWidth: 1,
    d: "M53.125,1.23908949 L53.125,13.9848633 L65.412115,13.9848633 L53.125,1.23908949 Z",
    strokeLinejoin: "square",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("text", {
    id: ".xlsx",
    fontFamily: "OpenSans-SemiBold, Open Sans",
    fontSize: 16.3636364,
    fontWeight: 500,
    fill: "#4F5E65"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 20.2113104,
    y: 68.9090909
  }, ".xlsx")), /*#__PURE__*/React.createElement("g", {
    id: "microsoft-word",
    transform: "translate(0.000000, 14.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38,7 C41.0021429,7 43.9978571,7 47,7 C47,7.99857143 47,9.00142857 47,10 C43.9978571,10 41.0021429,10 38,10 C38,9.00142857 38,7.99857143 38,7 Z",
    id: "path58",
    fill: "#207245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38,12 C41.0021429,12 43.9978571,12 47,12 C47,12.9985714 47,14.0014286 47,15 C43.9978571,15 41.0021429,15 38,15 C38,14.0014286 38,12.9985714 38,12 Z",
    id: "path90",
    fill: "#207245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38,17 C41.0021429,17 43.9978571,17 47,17 C47,17.9985714 47,19.0014286 47,20 C43.9978571,20 41.0021429,20 38,20 C38,19.0014286 38,17.9985714 38,17 Z",
    id: "path108",
    fill: "#207245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38,22 C41.0021429,22 43.9978571,22 47,22 C47,22.9985714 47,24.0014286 47,25 C43.9978571,25 41.0021429,25 38,25 C38,24.0014286 38,22.9985714 38,22 Z",
    id: "path114",
    fill: "#207245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38,27 C41.0021429,27 43.9978571,27 47,27 C47,27.9985714 47,29.0014286 47,30 C43.9978571,30 41.0021429,30 38,30 C38,29.0014286 38,27.9985714 38,27 Z",
    id: "path120",
    fill: "#207245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,7 C53.0021429,7 55.9978571,7 59,7 C59,7.99857143 59,9.00142857 59,10 C55.9978571,10 53.0021429,10 50,10 C50,9.00142857 50,7.99857143 50,7 Z",
    id: "path58-copy-2",
    fill: "#207245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,12 C53.0021429,12 55.9978571,12 59,12 C59,12.9985714 59,14.0014286 59,15 C55.9978571,15 53.0021429,15 50,15 C50,14.0014286 50,12.9985714 50,12 Z",
    id: "path90-copy-2",
    fill: "#207245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,17 C53.0021429,17 55.9978571,17 59,17 C59,17.9985714 59,19.0014286 59,20 C55.9978571,20 53.0021429,20 50,20 C50,19.0014286 50,17.9985714 50,17 Z",
    id: "path108-copy-2",
    fill: "#207245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,22 C53.0021429,22 55.9978571,22 59,22 C59,22.9985714 59,24.0014286 59,25 C55.9978571,25 53.0021429,25 50,25 C50,24.0014286 50,22.9985714 50,22 Z",
    id: "path114-copy-2",
    fill: "#207245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,27 C53.0021429,27 55.9978571,27 59,27 C59,27.9985714 59,29.0014286 59,30 C55.9978571,30 53.0021429,30 50,30 C50,29.0014286 50,27.9985714 50,27 Z",
    id: "path120-copy-2",
    fill: "#207245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,7 C29.0021429,7 31.9978571,7 35,7 C35,7.99857143 35,9.00142857 35,10 C31.9978571,10 29.0021429,10 26,10 C26,9.00142857 26,7.99857143 26,7 Z",
    id: "path58-copy",
    fill: "#207245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,12 C29.0021429,12 31.9978571,12 35,12 C35,12.9985714 35,14.0014286 35,15 C31.9978571,15 29.0021429,15 26,15 C26,14.0014286 26,12.9985714 26,12 Z",
    id: "path90-copy",
    fill: "#207245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,17 C29.0021429,17 31.9978571,17 35,17 C35,17.9985714 35,19.0014286 35,20 C31.9978571,20 29.0021429,20 26,20 C26,19.0014286 26,17.9985714 26,17 Z",
    id: "path108-copy",
    fill: "#207245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,22 C29.0021429,22 31.9978571,22 35,22 C35,22.9985714 35,24.0014286 35,25 C31.9978571,25 29.0021429,25 26,25 C26,24.0014286 26,22.9985714 26,22 Z",
    id: "path114-copy",
    fill: "#207245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,27 C29.0021429,27 31.9978571,27 35,27 C35,27.9985714 35,29.0014286 35,30 C31.9978571,30 29.0021429,30 26,30 C26,29.0014286 26,27.9985714 26,27 Z",
    id: "path120-copy",
    fill: "#207245"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#207245",
    points: "22 0.00471947195 22 35.75 0 32.0357756 0 3.82277228 22 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4213198,10.2081218 C14.5685279,10.1269036 15.7208122,10.0558376 16.8730964,10 C15.5177665,12.7766497 14.1573604,15.5532995 12.7766497,18.319797 C14.1725888,21.1624365 15.5989848,23.9847716 17,26.8274112 C15.7766497,26.7563452 14.5583756,26.680203 13.3350254,26.5939086 C12.4720812,24.4771574 11.4213198,22.4314721 10.8020305,20.2182741 C10.1116751,22.2791878 9.12690355,24.2233503 8.33502538,26.2436548 C7.22335025,26.2284264 6.11167513,26.1827411 5,26.1370558 C6.30456853,23.5837563 7.56345178,21.0101523 8.90862944,18.4720812 C7.76649746,15.857868 6.51269036,13.2944162 5.33502538,10.6954315 C6.45177665,10.6294416 7.56852792,10.5634518 8.68527919,10.5025381 C9.44162437,12.4873096 10.2690355,14.4467005 10.893401,16.4822335 C11.5634518,14.3248731 12.5634518,12.2944162 13.4213198,10.2081218 Z",
    id: "path72",
    fill: "#FFFFFF"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgXlsx, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/xlsx.5e9d3419.svg";
export { ForwardRef as ReactComponent };